import api from './api'

export const projectService = {
  getProjects: async ({ status = 'active', search } = {}) => {
    const params = { status }
    if (search) params.search = search
    const response = await api.get('/projects', { params })
    return response.data
  },

  getProject: async (id) => {
    const response = await api.get(`/projects/${id}`)
    return response.data
  },

  createProject: async (data) => {
    const response = await api.post('/projects', data)
    return response.data
  },

  updateProject: async (id, data) => {
    const response = await api.put(`/projects/${id}`, data)
    return response.data
  },

  archiveProject: async (id) => {
    const response = await api.put(`/projects/${id}/archive`)
    return response.data
  },

  reorderProjects: async (projects) => {
    const response = await api.put('/projects/reorder', { projects })
    return response.data
  },

  // Statuses
  getStatuses: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/statuses`)
    return response.data
  },

  createStatus: async (projectId, data) => {
    const response = await api.post(`/projects/${projectId}/statuses`, data)
    return response.data
  },

  updateStatus: async (projectId, statusId, data) => {
    const response = await api.put(`/projects/${projectId}/statuses/${statusId}`, data)
    return response.data
  },

  reorderStatuses: async (projectId, statuses) => {
    const response = await api.put(`/projects/${projectId}/statuses/reorder`, { statuses })
    return response.data
  },

  deleteStatus: async (projectId, statusId) => {
    const response = await api.delete(`/projects/${projectId}/statuses/${statusId}`)
    return response.data
  },

  // Members
  getMembers: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/members`)
    return response.data
  },

  addMember: async (projectId, data) => {
    const response = await api.post(`/projects/${projectId}/members`, data)
    return response.data
  },

  removeMember: async (projectId, userId) => {
    const response = await api.delete(`/projects/${projectId}/members/${userId}`)
    return response.data
  },
}
